import { element, globalEvent } from '@shared/easyfy.core';
import Toggle from '@clientShared/toggle';
import { GetSubscriptionFlyoutViewForProductList } from '@clientWebServices/productoptions.service';
import { SALES_UNITS_CLOSE } from '@clientWebModules/salesunitselector';
import MessageService from '@clientWebServices/message.service';

export default class SubscriptionHelper {
  static Instance: SubscriptionHelper;

  constructor() {
    SubscriptionHelper.Instance = this;
    globalEvent({
      type: 'click',
      events: [
        {
          action: 'subscribe',
          callback: this.loadSubscriptionFlyout,
        },
      ],
    });
  }

  private openFlyout(flyout: Element, trigger: HTMLElement) {
    Toggle.Instance.lastTriggerElement = trigger;
    document.body.classList.add('noof', 'overlay-is-active');
    flyout.setAttribute('data-toggle-open', '');
    Toggle.Instance.triggerFlyoutImpression(flyout);
    if (!(flyout instanceof HTMLElement)) return;
    Toggle.Instance.trapFocusInFlyout(flyout);
    Toggle.Instance.moveFocusToElement(flyout);
  }

  loadSubscriptionFlyout = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();

    const closeSalesUnitSelector = new CustomEvent(SALES_UNITS_CLOSE);
    document.dispatchEvent(closeSalesUnitSelector);

    const button: HTMLElement = e.target as HTMLElement;
    const searchProductId = button.getAttribute('data-searchProductId');

    const flyout = element(`[data-container="product-options-selector-subscription-${searchProductId}"]`) ?? false;

    if (button && searchProductId) {
      if (!flyout) {
        GetSubscriptionFlyoutViewForProductList(searchProductId)
          .then((res) => {
            if (res?.data?.success && res?.data?.content?.partialHtml != null) {
              const content = document.createRange().createContextualFragment(res?.data?.content?.partialHtml).firstElementChild;
              if (!content) return;
              document.body.appendChild(content);
              this.openFlyout(content, button);
            } else {
              res?.data?.message != null
                ? MessageService.Instance.displayErrorMessage(res?.data?.message)
                : MessageService.Instance.displayDefaultErrorMessage();
            }
          })
          .catch((err) => {
            console.log(err);
            MessageService.Instance.displayDefaultErrorMessage();
          });
      } else {
        this.openFlyout(flyout, button);
      }
    }

    return false;
  };
}
